import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const CustomModal = (props) => {
    return (
        <Modal body={ 'padding-right: 0 !important' } isOpen={props.modal} toggle={props.toggle} size={props.size ?? 'lg'}>
            <ModalHeader>{props.title}</ModalHeader>
            <ModalBody>
                {props.children}
            </ModalBody>
            {!props.nonFooter ? <ModalFooter>
                <div className={'custom-modal-footer'}>
                    <Button color="danger" onClick={props.toggle}>
                        {props.customSalir ? props.customSalir : 'Salir'}</Button>
                    {!props.secondButton ? <Button color="primary" onClick={props.onClick} disabled={props.buttonLoading}>
                        {props.buttonTitle}</Button> : null}
                </div>
            </ModalFooter> : null}
        </Modal>
    );
}

export default CustomModal;